<div class="retry-content">
  <div>
    <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
      {{ header }}
    </h2>
    <mat-dialog-content>
      <p>
        Provide feedback and communicate with {{ studentName }} about their
        work.
      </p>
      <textarea
        [(ngModel)]="message"
        name="message"
        id="retry-message"
      ></textarea>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="centered">
    <div class="save-cancel-button-row">
      <button
        id="cancel-button"
        class="header-text"
        type="button"
        mat-button
        (click)="cancel()"
      >
        {{ 'Cancel' | uppercase }}
      </button>
      <button
        id="form-submit-button"
        class="header-text"
        type="submit"
        mat-button
        [mat-dialog-close]="message"
        cdkFocusInitial
        (click)="submit()"
      >
        {{ 'Send' | uppercase }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
